/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinkkindsignup3Inputs */

const en_ticketlinkkindsignup3 = /** @type {(inputs: Ticketlinkkindsignup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form`)
};

const de_ticketlinkkindsignup3 = /** @type {(inputs: Ticketlinkkindsignup3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formular`)
};

/**
* | output |
* | --- |
* | "Form" |
*
* @param {Ticketlinkkindsignup3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinkkindsignup3 = /** @type {((inputs?: Ticketlinkkindsignup3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinkkindsignup3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinkkindsignup3(inputs)
	return de_ticketlinkkindsignup3(inputs)
});
export { ticketlinkkindsignup3 as "ticketLinkKindSignup" }